import { Page } from "@/components/page"
import { CRUDLoader } from "@/components/page/crudloader"
import { useDatabaseItem } from "@/components/page/hooks"
import { ToMarkdown } from "@/components/ui/tomarkdown"
import { Button } from "@/components/ui/button"
import { Download, ScrollText } from "lucide-react"
import { downloadChangeMarkdown } from "./download"

export const agentsChangelog_crud = {
  title: "Agent Change",
  route: "/settings/agents-changelog/:id",
  component,
  group: "settings",
  resource: "agents",
  icon: ScrollText,
  action: "read",
} satisfies PageConfig

export function component() {

  const { data, loading } = useDatabaseItem("agents_changelog")

  if (loading) return <CRUDLoader />

  console.log(data)


  return <Page>
    <div className="relative h-full">
      <Button variant="ghost" size="icon" className="absolute top-2 right-2 z-10" title="Download as Markdown" onClick={() => downloadChangeMarkdown(data?.title, data?.document)}><Download className="h-4 w-4" /></Button>
      <div className="h-full overflow-auto p-4">
        <ToMarkdown variant="document">{data?.document || ""}</ToMarkdown>
      </div>
    </div>
  </Page>
}
